import { createAction, handleActions, Action } from 'redux-actions';
import { Dispatch } from 'redux';

import { useRedux } from 'util/hook/redux';
import { api } from 'util/api';
// import { V1FormSubmitContactCreateRequestPayload } from 'util/api/swaggerApi/data-contracts';
// import { handlePurposeValue } from 'util/helper';

import {
	V1WebEcpayPaymentCreateRequestPayload,
	PaymentResultResource,
} from 'util/api/swaggerApi/data-contracts';
import { GetState, State as GlobalState } from './reducers';

export const updateReceiptForm = createAction(
	'UPDATE_CONTACT_INQUIRY_FORM',
	({ key, data, error }: ReceiptFormItemPayload) => ({
		key,
		data,
		error,
	}),
);

export const updateRecordId = createAction(
	'UPDATE_RECORD_ID',
	({ key, data, error }: ReceiptFormItemPayload) => ({
		key,
		data,
		error,
	}),
);

export const clearForm = createAction('CLEAR_FORM', (type: string) => {
	let clearData;

	switch (type) {
		case 'receiptForm':
			clearData = defaultReceiptForm;
			break;
		default:
			break;
	}

	return {
		type,
		data: clearData,
	};
});

export const submitPayment = createAction(
	'SUBMIT_PAYMENT',
	() => async (dispatch: Dispatch, getState: GetState) => {
		try {
			const {
				receiptForm: { receiptForm },
				records: { record },
			} = getState();

			const {
				name,
				taxCode,
				email,
				donateCode,
				cloudInvoice,
				certificate,
				paymentType,
				receiptType,
			} = receiptForm;

			const recordId = Number(localStorage.getItem('recordId'));

			let formData = {};

			if (receiptType.value === '三聯式（公司用）') {
				formData = {
					registration_id: recordId,
					amount: Number(record?.price?.replace(/,/g, '')),
					choose_payment: paymentType.value,
					item_name: record?.sessionName,
					customer_email: email.value,
					invoice_type: 'Triplicate',
					customer_name: name.value,
					customer_identifier: taxCode.value,
				};
			} else if (receiptType.value === '二聯式（個人消費）' && cloudInvoice.value) {
				formData = {
					registration_id: recordId,
					amount: Number(record?.price?.replace(/,/g, '')),
					choose_payment: paymentType.value,
					item_name: record?.sessionName,
					customer_email: email.value,
					invoice_type: 'Duplicate',
					carrier_type: '3',
					carrier_num: `/${cloudInvoice.value}`,
				};
			} else if (receiptType.value === '二聯式（個人消費）' && certificate.value) {
				formData = {
					registration_id: recordId,
					amount: Number(record?.price?.replace(/,/g, '')),
					choose_payment: paymentType.value,
					item_name: record?.sessionName,
					customer_email: email.value,
					invoice_type: 'Duplicate',
					carrier_type: '2',
					carrier_num: certificate.value,
				};
			} else if (receiptType.value === '捐贈發票') {
				formData = {
					registration_id: recordId,
					amount: Number(record?.price?.replace(/,/g, '')),
					choose_payment: paymentType.value,
					item_name: record?.sessionName,
					customer_email: email.value,
					invoice_type: 'Donation',
					love_code: donateCode.value,
				};
			}

			const { v1WebEcpayPaymentCreate } = api;
			const { data, status } = await v1WebEcpayPaymentCreate(
				formData as V1WebEcpayPaymentCreateRequestPayload,
			);

			if (status === 200) {
				return data?.data;
			}

			return data?.data;
		} catch (error) {
			type ErrorDetails = {
				[key: string]: string[];
			};

			const errors = (error as { error?: { errors?: ErrorDetails } }).error?.errors;
			const {
				receiptForm: { receiptForm },
			} = getState();

			// Explicitly define the keys you expect in receiptForm
			type ReceiptFormKeys = 'donateCode' | 'taxCode' | 'certificate' | 'cloudInvoice';

			const errorMappings: { [key: string]: { field: ReceiptFormKeys; defaultMessage: string } } = {
				loveCode: {
					field: 'donateCode',
					defaultMessage: '未找到相符的受捐單位',
				},
				customerIdentifier: {
					field: 'taxCode',
					defaultMessage: '未找到相符的統一編號',
				},
				carrierNum: {
					field: receiptForm.certificate.value ? 'certificate' : 'cloudInvoice',
					defaultMessage: receiptForm.certificate.value
						? '未找到相符的自然人憑證號碼'
						: '未找到相符的手機條碼',
				},
			};

			if (errors) {
				await Promise.all(
					Object.keys(errors).map(async key => {
						if (errorMappings[key]) {
							const { field, defaultMessage } = errorMappings[key];
							const message = errors[key][0] || defaultMessage;

							await dispatch(
								updateReceiptForm({
									key: field,
									value: receiptForm[field].value,
									data: { value: receiptForm[field].value },
									error: message,
								}),
							);
						}
					}),
				);
			}

			return '';
		}
	},
);

export const getPaymentResult = createAction('GET_PAYMENT_RESULT', () => async () => {
	try {
		const { v1WebEcpayPaymentResultDetail } = api;

		const recordId = Number(localStorage.getItem('recordId'));
		const data = await v1WebEcpayPaymentResultDetail(recordId);

		const result = data?.data || [];

		return result;
	} catch (error) {
		console.log('error!', error);

		return [];
	}
});

export interface ReceiptFormItemPayload {
	key: string;
	value: HTMLInputElement['value'];
	data: FormItemProperty;
	error?: string;
}

export const defaultReceiptForm = {
	name: { value: '', error: '' },
	taxCode: { value: '', error: '' },
	email: { value: '', error: '' },
	donateCode: { value: '', error: '' },
	cloudInvoice: { value: '', error: '' },
	certificate: { value: '', error: '' },
	paymentType: { value: '', error: '' },
	receiptType: { value: '', error: '' },
};

export const defaultRecordId = {
	recordId: { value: '' },
};

export interface FormItemProperty {
	value: HTMLInputElement['value'] | string;
	error?: string;
}

export interface receiptFormProperty {
	name: FormItemProperty;
	taxCode: FormItemProperty;
	email: FormItemProperty;
	donateCode: FormItemProperty;
	cloudInvoice: FormItemProperty;
	certificate: FormItemProperty;
	paymentType: FormItemProperty;
	receiptType: FormItemProperty;
	[key: string]: FormItemProperty;
}

export interface recordIdProperty {
	recordId: FormItemProperty;
	[key: string]: FormItemProperty;
}

export interface State {
	loading: boolean;
	receiptForm: receiptFormProperty & {
		userId?: FormItemProperty;
		tourGroupNumber?: FormItemProperty;
		tourName?: FormItemProperty;
	};
	recordId: recordIdProperty & {
		userId?: FormItemProperty;
		tourGroupNumber?: FormItemProperty;
		tourName?: FormItemProperty;
	};
	htmlContent: string;
	resultData: PaymentResultResource | undefined;
}

export const defaultState: State = {
	loading: false,
	receiptForm: defaultReceiptForm,
	recordId: defaultRecordId,
	htmlContent: '',
	resultData: undefined,
};

export const reducer = {
	receiptForm: handleActions<State, any>( // eslint-disable-line @typescript-eslint/no-explicit-any
		{
			UPDATE_CONTACT_INQUIRY_FORM: (state, action: Action<ReceiptFormItemPayload>) => ({
				...state,
				error: '',
				receiptForm: {
					...state.receiptForm,
					[action.payload.key]: {
						...state.receiptForm[action.payload.key],
						...action.payload.data,
						error: action.payload.error as string,
					},
				},
			}),

			UPDATE_RECORD_ID: (state, action: Action<ReceiptFormItemPayload>) => ({
				...state,
				error: '',
				recordId: {
					...state.recordId,
					[action.payload.key]: {
						...state.recordId[action.payload.key],
						...action.payload.data,
						error: action.payload.error as string,
					},
				},
			}),

			CLEAR_FORM: (state, action) => ({
				...state,

				[action.payload.type]: action.payload.data,
			}),

			SUBMIT_PAYMENT_PENDING: state => ({
				...state,
				loading: true,
			}),

			SUBMIT_PAYMENT_FULFILLED: (state, action) => ({
				...state,
				htmlContent: action.payload,
				loading: false,
			}),

			GET_PAYMENT_RESULT_PENDING: state => ({
				...state,
				loading: true,
			}),

			GET_PAYMENT_RESULT_FULFILLED: (state, action) => ({
				...state,
				resultData: action.payload,
				loading: false,
			}),
		},
		defaultState,
	),
};

const contactInquiryFormActionsMap = {
	updateReceiptForm,
	clearForm,
	updateRecordId,
	submitPayment,
	getPaymentResult,
};

const mapHooksToState = (state: GlobalState) => ({
	receiptForm: state.receiptForm.receiptForm,
	recordId: state.receiptForm.recordId,
	htmlContent: state.receiptForm.htmlContent,
	resultData: state.receiptForm.resultData,
	loading: state.receiptForm.loading,
});

type ContactInquiryFormSelector = ReturnType<typeof mapHooksToState>;
type ContactInquiryFormActionsMap = typeof contactInquiryFormActionsMap;

export const useReceiptForm = () =>
	useRedux<ContactInquiryFormSelector, ContactInquiryFormActionsMap>(
		mapHooksToState,
		contactInquiryFormActionsMap,
	);
